import {
  Box,
  Button,
  Paper,
  Snackbar,
  Typography,
  Grid,
  MenuItem,
  Autocomplete
} from "@mui/material";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import styles from '../../../styles.module.css';
import {
  ActionMsg,
  Breadcrumb,
  Cancel,
  CTSinput,
  HandleCloseSnackbar,
  useMessageHandler
} from "../../reusableComponent/Reusables";
import SaveIcon from '@mui/icons-material/Save';
import { useDispatch, useSelector } from "react-redux";
import {

  addCylinderTagMap,
  editDeleteCylinderTagMap

} from "../../../actions/actions";
import dayjs from "dayjs";
import cylinderMasterService from "../../../services/masters/cylinderMaster.Service"
import cylinderTag from "../../../services/masters/cylinderTagNoMaster.Service"
import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";

const Addcyltagmap = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { handleSubmit } = useForm();
  const urlLocation = useLocation();
  const editData = urlLocation?.state || null;

  // ✅ Get userInfo safely from sessionStorage
  const login_details = sessionStorage.getItem('loginUser');
  const userD = login_details ? JSON.parse(login_details) : null;
  const userInfo = userD?.result?.userInfo;

  // ✅ Redirect if userInfo is not available
  useEffect(() => {
    if (!userInfo) {
      navigate('/'); // fallback route
    }
  }, [userInfo, navigate]);

  const [data, setData] = useState({
    cyl_tag_id: editData?.cyl_tag_id || '',
    cyl_id: editData?.cyl_id || '',
    cylinder_no: editData?.cylinder_no || '',
    tag_no: editData?.tag_no || '',
  });

  const handleChange = ({ target: { name, value } }) => {
    if (name === "cylinder_no") {
      // Find the corresponding cylinder object based on the selected cylinder_no
      const selectedCylinder = cylinder.find((cyl) => cyl.cylinder_no === value);
      setData((prev) => ({
        ...prev,
        [name]: value, // Update cylinder_no
        cyl_id: selectedCylinder ? selectedCylinder.cyl_id : '', // Update cylinder_id
      }));
    } else {
      setData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const onSubmit = async () => {
    const currentTime = dayjs().format('YYYY-MM-DD HH:mm:ss');

    const Cyltagmapdata = {
      ...data,
      modified_at: currentTime,
      modified_by: userInfo?.user_id,
      created_at: editData ? editData.created_at : currentTime,
      created_by: editData ? editData.created_by : userInfo?.user_id,
      changedUpdatedValue: editData ? 'edit' : 'create',
    };

    try {
      if (editData) {
        await cylinderTag.editDeleteCylinderTagMap(Cyltagmapdata);
      } else {
        await cylinderTag.addCylinderTagMap(Cyltagmapdata);
      }
      setSuccessMessage(editData ? "Updated successfully" : "Added successfully");
      setTimeout(() => navigate(-1), 1000);
      //  setTimeout(()=>navigate(-1),1000);
    } catch (error) {
      setSuccessMessage("Error occurred");
    }
  };

  const [successMessage, setSuccessMessage] = useState(null);
  // const respMsgState = useSelector(state => state.CylinderTagMapping?.message || state.Cyltagmap?.message);
  // const { shouldShowMsg, responseMessage } = useMessageHandler(
  //   null,
  //   setSuccessMessage,
  //   respMsgState
  // );

  // useEffect(() => {
  //   if (shouldShowMsg) {
  //     setSuccessMessage(responseMessage);
  //   }
  // }, [shouldShowMsg, responseMessage]);
  const [cylinder, setCylinder] = useState([]);


  useEffect(() => {
    async function fetchData() {
      try {
        const [cylinderData,] = await Promise.all([
          cylinderMasterService.getCylinderList({ page: 0, size: 10, searchKey: "" })
        ]);
        setCylinder(cylinderData);
      } catch (error) {
        console.error("Data fetching failed", error);
      }
    }

    fetchData();
  }, []);

  return (
    <Box className={`${styles.cts_page}`} sx={{ padding: '0px !important', margin: '0px !important' }}>
      <Box className={`${styles.body}`}>
        <Breadcrumb routeSegments={[{ name: 'Cylinder Tag Mapping Master' }]} />

        <Box sx={{ display: "flex" }}>
          <Grid container spacing={2} sx={{ pt: 1.5, pb: 1.5 }}>
            <Grid item md={7} sm={6} xs={12}>
              <Box sx={{ display: "flex" }}>
                <Typography className={`${styles.header_txt}`}>
                  {editData ? 'Update' : 'Create'} Cylinder Tag Master
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Box>


        <Box>
          <form onSubmit={handleSubmit(onSubmit)}>
            <Grid container spacing={2}>

              <Grid item xs={12} sm={6}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={12}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: { xs: "column", sm: "row" },
                        alignItems: { xs: "stretch", sm: "center" }, }}>
                      <Typography
                        className={`${styles.label_Txt_add}`}>
                        Cylinder No <span style={{ color: 'red' }}>*</span>
                      </Typography>
                      <Autocomplete
                        disablePortal
                        options={cylinder || []}
                        clearIcon={false}
                        getOptionLabel={(option) =>
                          typeof option === 'string' ? option : option.cylinder_no || ''
                        }
                        value={
                          cylinder.find((c) => c.cylinder_no === data.cylinder_no) ||
                          (data.cylinder_no ? { cylinder_no: data.cylinder_no } : null)
                        }
                        onChange={(event, newValue) => {
                          handleChange({
                            target: {
                              name: 'cylinder_no',
                              value: newValue ? newValue.cylinder_no : '',
                            },
                          });
                        }}
                        isOptionEqualToValue={(option, value) =>
                          option.cylinder_no === value.cylinder_no
                        }
                        renderOption={(props, option) => (
                          <MenuItem {...props} className={styles.cts_lable}>
                            {option.cylinder_no}
                          </MenuItem>
                        )}
                        renderInput={(params) => (
                          <CTSinput
                            {...params}
                            // label="Cylinder No"
                            // placeholder="Select or type cylinder no"
                            variant="outlined"
                            size="small"
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            InputProps={{
                              ...params.InputProps,
                              className: styles.CTSinput_Box,
                            }}
                          />
                        )}
                        sx={{ width: '100%' }}
                      />
                    </Box>
                  </Grid>


                  <Grid item xs={12} sm={12}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: { xs: "column", sm: "row" },
                        alignItems: { xs: "stretch", sm: "center" }, }}>
                      <Typography
                        className={`${styles.label_Txt_add}`} >
                        Tag No <span style={{ color: 'red' }}>*</span> :
                      </Typography>
                      <CTSinput
                        size="small"
                        fullWidth
                        type="text"
                        onChange={handleChange}
                        name="tag_no"
                        value={data.tag_no}
                        required
                         InputProps={{
                                                  className: styles.CTSinput_Box,
                                                }}
                      />
                    </Box>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} className={`${styles.grid_input}`}>
                <Box className={`${styles.btn_container}`}>
                  <Box>
                    <Button
                      id={`${styles.btn_save}`}
                      type="submit"
                    >
                      <SaveIcon className={`${styles.btn_cancel_txt}`} />{" "}
                      <Typography className={`${styles.btn_cancel_txt}`}> {editData ? "Update" : "Save"}</Typography>
                    </Button>
                  </Box>
                  <Box>
                    <Cancel />
                  </Box>
                </Box>
              </Grid>

            </Grid>
          </form>
        </Box>

        <ReusableSnackbar
          open={!!successMessage}
          onClose={(event, reason) => {
            if (reason !== 'clickaway') {
              setSuccessMessage("");
            }
          }}
          message={successMessage}
          autoHideDuration={2000}
          vertical="top"
          horizontal="right"
        />
      </Box>
    </Box>
  );
};

export default Addcyltagmap;
